import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onboarding-signup-wrapper" }
const _hoisted_2 = {
  class: "onboarding-signup-wrapper__loading",
  "aria-hidden": "true"
}

import { defineAsyncComponent } from 'vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import {
  passwordlessSignup18304Experiment,
  signupPageNullExperiment17503Experiment,
} from '@/services/ab'
import Signup from './Signup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SignupWrapper',
  props: {
    nextOnboardingPage: { type: Function }
  },
  setup(__props: any) {

const SignupAsync = defineAsyncComponent(async () => {
  const startupPromises = [
    signupPageNullExperiment17503Experiment(),
    passwordlessSignup18304Experiment(),
  ]

  await Promise.allSettled(startupPromises)
  return Signup
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Suspense, null, {
      fallback: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ButtonSpinner)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(SignupAsync), { nextOnboardingPage: __props.nextOnboardingPage }, null, 8, ["nextOnboardingPage"])
      ]),
      _: 1
    }))
  ]))
}
}

})